<template>
  <BaseModal
    :value="true"
    @input="$emit('close')"
    id="infoauto-address-phone-modal"
  >
    <template v-slot:header>
      {{ $t("message.order.manage_infoauto_addresses_phones") }}
    </template>
    <div class="modal-wrapper">
      <div v-if="selectable" class="info-banner">
        <svg
          class="w-5 h-5"
          fill="none"
          stroke="currentColor"
          viewBox="0 0 24 24"
        >
          <path
            stroke-linecap="round"
            stroke-linejoin="round"
            stroke-width="2"
            d="M13 16h-1v-4h-1m1-4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z"
          />
        </svg>
        <span>Click on any enabled address or phone to select it</span>
      </div>
      <InfoautoCustomerAddressesPhones
        :showDisabled="showDisabled"
        @toggle-disabled="showDisabled = !showDisabled"
        :customerId="customerId"
        :selectable="selectable"
        :currentAddress="currentAddress"
        @address-selected="handleAddressSelected"
        @phone-selected="handlePhoneSelected"
      />
    </div>
  </BaseModal>
</template>

<script>
import InfoautoCustomerAddressesPhones from "./InfoautoCustomerAddressesPhones.vue";

export default {
  components: {
    InfoautoCustomerAddressesPhones
  },
  props: {
    customerId: {
      type: String,
      required: true
    },
    selectable: {
      type: Boolean,
      default: false
    },
    // The order's address, to mark it (see InfoautoCustomerAddressesPhones)
    currentAddress: {
      type: Object,
      default: null
    }
  },
  data() {
    return {
      showDisabled: false
    };
  },
  methods: {
    handleAddressSelected(address) {
      this.$emit("address-selected", address);
    },
    handlePhoneSelected(phone) {
      this.$emit("phone-selected", phone);
    }
  }
};
</script>

<style lang="scss" scoped>
#infoauto-address-phone-modal {
  // .modal-content es de BaseModal: sin ::v-deep el scoped no le llegaba y
  // estas medidas nunca se aplicaban
  ::v-deep > .modal-content {
    width: 95%;
    max-width: 1200px;
    height: 90vh;
    overflow-y: auto;
  }

  // Movil: pantalla completa y un cerrar del tamano de un dedo (la X gris de
  // BaseModal casi no se veia ni se podia tocar)
  @media (max-width: 767px) {
    padding: 0;

    ::v-deep > .modal-content {
      width: 100%;
      height: 100%;
      max-height: none;
      border-radius: 0;

      > .header {
        padding: 6px 52px 6px 12px;
        font-size: 15px;
        font-weight: 600;
        line-height: 1.3;
      }

      > .header .close {
        top: 50%;
        right: 4px;
        display: flex;
        align-items: center;
        justify-content: center;
        width: 44px;
        height: 44px;
        padding: 0;
        transform: translateY(-50%);
        font-size: 32px;
        color: #374151;
      }
    }
  }
}

.modal-wrapper {
  padding: 1rem;

  @media (max-width: 767px) {
    padding: 0.5rem 0.625rem 1rem;
  }
}

.info-banner {
  display: flex;
  align-items: center;
  gap: 0.75rem;
  background-color: #dbeafe;
  border-left: 4px solid #3b82f6;
  padding: 1rem;
  margin-bottom: 1rem;
  border-radius: 0.375rem;
  color: #1e40af;
  font-weight: 500;

  // Movil: una franja fina, no una caja de tres lineas
  @media (max-width: 767px) {
    gap: 0.5rem;
    padding: 0.375rem 0.625rem;
    margin-bottom: 0.5rem;
    border-left-width: 3px;
    font-size: 14px;
    line-height: 1.3;

    svg {
      flex-shrink: 0;
      width: 1rem;
      height: 1rem;
    }
  }
}
</style>
